'use client';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { FaFacebook } from 'react-icons/fa';

function BlogShareFacebook() {
  const [shareUrl, setShareUrl] = useState('');
  const pathname = usePathname();
  const { t } = useTranslations();

  useEffect(() => {
    setShareUrl(window.location.href);
  }, [pathname]);

  return (
    <div>
      <a
        href={shareUrl ? `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}` : undefined}
        target="_blank"
        rel="noopener noreferrer"
        className="flex max-w-min"
      >
        <div className="flex max-w-min gap-3 rounded-lg bg-[#415B9E] px-4 py-2 text-primary-foreground hover:bg-[#415B9E]/80">
          <FaFacebook className="h-6 w-6" />
          <p className="whitespace-nowrap">{t('text1047')}</p>
        </div>
      </a>
    </div>
  );
}

export default BlogShareFacebook;
